import { render } from "./cardlink.vue?vue&type=template&id=097e4e27"
import script from "./cardlink.vue?vue&type=script&lang=js"
export * from "./cardlink.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__